/*
    Change from ccrcc to gender 
*/

export default function generateBarplot(
    {
        track,
        divId,
        percentView,
        sampleMeta,
        trackDetails,
    }
) {
    const Plotly = window.Plotly

    let data = []

    const ccRCCAll = getCCRCC({ 
        sampleMeta, 
    }).length
    const nonCCRCCAll = getnonCCRCC({ 
        sampleMeta, 
    }).length
    const totalAll = ccRCCAll + nonCCRCCAll

    console.log("printing totalAll in barplotly.js")
    console.log(totalAll)


    trackDetails[track].forEach((category) => {
        console.log("reached forEach")
        const categoryLabel = category.label
        const ccRCC = getCohortCCRCC({ 
            sampleMeta, 
            track, 
            categoryLabel,
        }).length
        const nonCCRCC = getCohortnonCCRCC({ 
            sampleMeta, 
            track, 
            categoryLabel,
        }).length

        console.log( "testing if data got fed correctly" )
        console.log( "Male Data" )
        console.log(ccRCC)
        console.log("Female Data")
        console.log(nonCCRCC)
        
        const total = ccRCC + nonCCRCC

        let yValue, yValueText

        if (percentView) {
            yValue = [
                Math.round(total/totalAll * 100), 
                Math.round(ccRCC/ccRCCAll * 100), 
                Math.round(nonCCRCC/nonCCRCCAll * 100)
            ]
            yValueText = yValue.map(el => `${el} %`)
        } else {
            yValue = [
                total,
                ccRCC,
                nonCCRCC,
            ]
            yValueText = yValue.map(el => `${el}`)
        }
        let trace = {
            x: ['total', 'male', 'female'],
            y: yValue,
            text: yValueText,
            name: categoryLabel,
            type: 'bar',
            marker: {
                color: category.color
            }
          }

        data.push(trace)
    })
      
    data.reverse()

    var layout = {
        width: 500,
        barmode: 'stack',
        title: track,
        legend: {
            orientation: 'v',
            // traceorder: 'reversed',
        },
        // textposition: 'inside',
        // xanchor: 'right',
        hovermode: true,
        margin: {
            autoexpand: false,
            t: 50,
            r: 300,
        }
    }
      
    Plotly.newPlot(divId, data, layout);
}

function getCohortCCRCC({ sampleMeta, track, categoryLabel }) {
    console.log("printing out track")
    console.log(track)
    return Object.entries(sampleMeta)
        .filter(([, meta]) =>  meta.Sex === 'Male' && 
            meta[track] === categoryLabel)
        .map(([sample, ]) => sample)
}

function getCohortnonCCRCC({ sampleMeta, track, categoryLabel }) {
    
    return Object.entries(sampleMeta)
        .filter(([, meta]) =>  meta.Sex !== 'Male' 
            && meta[track] === categoryLabel)
        .map(([sample, ]) => sample)
}

function getCCRCC({ sampleMeta }) {
    console.log( "printing sample Meta in barplotly.js" )
    console.log( sampleMeta )
    return Object.entries(sampleMeta)
        .filter(([, meta]) =>  meta.Sex === 'Male')
        .map(([sample, ]) => sample)
}

function getnonCCRCC({ sampleMeta }) {
    return Object.entries(sampleMeta)
        .filter(([, meta]) =>  meta.Sex !== 'Male')
        .map(([sample, ]) => sample)
}